module.exports = __webpack_public_path__ + "img/aParty_111223_D.bb3170bd.jpg";